import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, Signal } from '@angular/core';
import { ToastNotificationComponent } from '@lx/shared/ui/error';
import { LoadingInfo, LoadingService, LoadingSpinnerComponent } from '@lx/shared/ui/loading-spinner';
import { RouterModule } from '@angular/router';
import { map, Observable } from 'rxjs';
import { GoogleAnalyticsEventEnum } from './google-analytics';
import { GoogleAnalyticsClickEventDirective } from '@lx/shared/google-analytics';
import { BreakpointObserverService } from '@lx/shared/utils-dom';
import { FocusTrapModule } from 'primeng/focustrap';
import { ScrollTopOnNavigateDirective } from '@lx/shared/ui/directives';
import { ReturnUrlService } from '@lx/quote-tool/lite/shared/services';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    LoadingSpinnerComponent,
    CommonModule,
    ToastNotificationComponent,
    GoogleAnalyticsClickEventDirective,
    FocusTrapModule,
    ScrollTopOnNavigateDirective,
  ],
  selector: 'lx-quote-tool-lite-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  protected loadingInfo: Signal<LoadingInfo>;

  protected withBackButton = false;
  protected backButtonLabel: string | undefined;
  protected returnUrl: string | undefined;

  protected desktop$: Observable<boolean> | undefined;

  protected readonly closeDataLayerEventName = GoogleAnalyticsEventEnum.QuoteSaveAndClose;

  private readonly loadingService = inject(LoadingService);
  private readonly returnUrlService = inject(ReturnUrlService);
  private readonly breakpointObserverService = inject(BreakpointObserverService);

  ngOnInit(): void {
    this.loadingInfo = this.loadingService.loading;
    this.desktop$ = this.breakpointObserverService.isMobile$.pipe(map((mobile) => !mobile));
    this.withBackButton = this.returnUrlService.hasReturnUrl();
    this.backButtonLabel = this.returnUrlService.getBackButtonLabel();
    this.returnUrl = this.returnUrlService.getReturnUrl();
  }

  protected onError(): void {
    this.loadingService.stopLoading();
  }
}
